module.exports = {
  ENTER: {
    KEY: 'Enter',
    KEY_CODE: 13,
  },
};
